import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getModel } from '../data/Model'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import LoginScreen from './LoginScreen'
import ForgotPasswordScreen from './ForgotPasswordScreen'
import ChangePasswordScreen from './ChangePasswordScreen'

class Welcome extends Component {
	render() {
		const Model = getModel()
		return (
			<Router>
				<div
					id='welcome'
					className={Model.auth_token ? 'hide fadein' : 'fadein'}
					style={{
						WebkitBackgroundSize: 'cover',
						MozBackgroundSize: 'cover',
						OBackgroundSize: 'cover',
						backgroundSize: 'cover',
					}}
				>
					<Route key='home' exact path='/' component={LoginScreen} />
					<Route
						key='forgot-password'
						exact
						path='/forgot-password'
						component={ForgotPasswordScreen}
					/>
					<Route
						key='change-password?:token'
						exact
						path='/change-password'
						component={ChangePasswordScreen}
					/>
					<div className='copyright'>
            Copyright &copy; 2018 Copyright Agent |{' '}
						<a href='http://www.copyrightagent.com'>www.copyrightagent.com</a> |
            Privacy Policy | Support
					</div>
				</div>
			</Router>
		)
	}
}

export default Welcome
